import React from "react";
import "./globalDirectory.css";

/**
 * Directory pagination (same chrome as membership/user-builder lists).
 * Pass page state from the parent; `onPageChange` receives the new page number.
 */
export default function GlobalDirectoryPaginationSection({
  page,
  totalPages,
  total,
  pageSize,
  onPageChange,
  label = "Pagination"
}) {
  return (
    <div className="gds-pagination">
      <nav
        className="user-builder-pagination"
        aria-label={label || "Pagination"}
      >
        <button
          type="button"
          className="user-builder-pagination-btn user-builder-pagination-btn--prev"
          disabled={page <= 1}
          onClick={() => onPageChange?.(page - 1)}
        >
          <span className="user-builder-pagination__chev" aria-hidden>
            ‹
          </span>
          Previous
        </button>
        <span className="user-builder-pagination-info">
          Page <strong>{page}</strong> of <strong>{totalPages}</strong>
          <span className="user-builder-pagination__dot" aria-hidden>
            ·
          </span>
          {total} total
          <span className="user-builder-pagination__dot" aria-hidden>
            ·
          </span>
          {pageSize} per page
        </span>
        <button
          type="button"
          className="user-builder-pagination-btn user-builder-pagination-btn--next"
          disabled={page >= totalPages}
          onClick={() => onPageChange?.(page + 1)}
        >
          Next
          <span className="user-builder-pagination__chev" aria-hidden>
            ›
          </span>
        </button>
      </nav>
    </div>
  );
}
